export default __webpack_public_path__ + "static/media/8.79309962.jpg";